import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useTenants = () => {
  const urlStr = `${getApiUrl()}/mega/tenant`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useTenant = (id) => {
  const urlStr = `${getApiUrl()}/mega/tenant/${id}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePostTenant = () => {
  const postTenant = async (payload) => {
    try {
      const url = `${getApiUrl()}/mega/tenant`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postTenant;
};

export const usePutTenant = () => {
  const putTenant = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/mega/tenant/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putTenant;
};

export const useDeleteTenant = () => {
  const deleteTenant = async (id) => {
    try {
      const url = `${getApiUrl()}/mega/tenant/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return deleteTenant;
};
